// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on
// (A4U6): the loader warms the home through the same queryOptions the screen reads — no waterfall.
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { OrgHome } from '../../../features/org/OrgHome'
import { orgHomeQuery } from '../../../features/org/queries'
import { Part } from '../../../shared/shell/StatePart'

export const Route = createFileRoute('/o/$orgSlug/')({
  staticData: { screenId: 'OrgHomeScreen', access: 'org.read', ownHeader: true },
  loader: async ({ context: { queryClient, membership } }) => {
    await queryClient.ensureQueryData(orgHomeQuery(membership.orgId))
    return { orgId: membership.orgId, orgName: membership.name }
  },
  component: OrgHomeScreen,
})

function OrgHomeScreen() {
  const { orgId, orgName } = Route.useLoaderData()
  const { orgSlug } = Route.useParams()
  return (
    <main data-testid={ids.orgHome.root}>
      <Part testId={ids.orgHome.skeleton}>
        <OrgHome orgId={orgId} orgName={orgName} orgSlug={orgSlug} />
      </Part>
    </main>
  )
}
